module.exports = __webpack_public_path__ + "img/MawulomEssel-Koomson.1c6237be.jpg";